import {useGameStore} from '../GameStoreContext.ts'

export const useIsReplay = () => {
    const isReplay = useGameStore((state) => state.gameReplay.isReplay)
    return isReplay
}
